import React, { forwardRef, useState } from 'react';
import XTerminal from '../Terminal';
import { TerminalIcon } from './Icons';

/**
 * TerminalPanel — card wrapper around xterm.js.
 *
 * Forwards its ref directly to the inner XTerminal so App.js can call
 * terminalRef.current.startRun() / .clear().
 *
 * Manages its own wsStatus state by receiving the onWsStatusChange callback
 * from XTerminal and updating the Live pill.
 */
const TerminalPanel = forwardRef(function TerminalPanel(
  { onRunStateChange, termBg, termText },
  ref
) {
  const [wsStatus, setWsStatus] = useState('idle'); // 'idle' | 'connecting' | 'connected' | 'disconnected'

  const pillClass =
    wsStatus === 'connected'    ? 'ws-pill ws-live' :
    wsStatus === 'connecting'   ? 'ws-pill ws-connecting' :
    wsStatus === 'disconnected' ? 'ws-pill ws-disconnected' :
    'ws-pill ws-idle';

  const pillLabel =
    wsStatus === 'connected'    ? 'Live' :
    wsStatus === 'connecting'   ? 'Connecting…' :
    wsStatus === 'disconnected' ? 'Disconnected' :
    'Ready';

  const handleClear = () => {
    ref?.current?.clear();
  };

  return (
    <div className="card terminal-card">

      {/* Header */}
      <div className="terminal-header card-header">
        <span className="terminal-icon" aria-hidden="true">
          <TerminalIcon size={14} />
        </span>
        <span className="terminal-header-label">Output</span>

        <span className={pillClass} aria-live="polite">
          <span className="ws-dot" aria-hidden="true" />
          {pillLabel}
        </span>

        <button
          className="terminal-clear-btn"
          onClick={handleClear}
          aria-label="Clear terminal"
        >
          Clear
        </button>
      </div>

      {/* xterm body */}
      <div className="terminal-body">
        <XTerminal
          ref={ref}
          onRunStateChange={onRunStateChange}
          onWsStatusChange={setWsStatus}
          termBg={termBg}
          termText={termText}
        />
      </div>

    </div>
  );
});

export default TerminalPanel;
